const keys = {
  modelName: 'Model name',
  load: 'Load',
  loadPercent: 'Load',
  cocLoad: 'Carry over capacity load',
  relievingDeck: 'Relieving deck',

  calcMinCSS: 'Min. theoretical CSS with actual feed',
  pminCSS: 'Amount < CSS',
  sieveSizeP80: 'P80',
  c1: 'C1',
  c2: 'C2',
  c3: 'C3',
  c4: 'C4',
  p1: 'P1',
  p2: 'P2',
  p3: 'P3',
  p4: 'P4',
  p5: 'P5',
  p6: 'P6',
  s1: 'S1',
  s2: 'S2',
  s3: 'S3',

  bedLoadFeed: 'bedLoadFeed',
  bedFeedMax: 'bedFeedMax',
  bedFeedMin: 'bedFeedMin',
  bedLoadDis: 'bedLoadDis',
  bedDisMax: 'bedDisMax',
  bedDisMin: 'bedDisMin',
  qnominal: 'qnominal',
  bedFeed: 'bedFeed',
  bedDis: 'bedDis',

  a: 'a',
  b: 'b',
  c: 'c',
  d: 'd',
  e: 'e',
  f: 'f',
  g: 'g',
  h: 'h',
  i: 'i',
  j: 'j',
  k: 'k',
  l: 'l',
  m: 'm',
  n: 'n',
  o: 'o',
  p: 'p',
  q: 'q',

  qspec: 'qspec',
  qthrough: 'qthrough',
  minWidth: 'Min width required',
  areaReq: 'Area required',

  operatingpowerdraw: 'Power draw',
  pmax: 'Pmax',
  pmax_Corr_F50_CSS: 'Pmax F50 SCS',
  pmax_Corr_MTPH: 'Pmax MTPH',
  pmax_Corr_SPEED: 'Pmax SPEED',
  pmax_Corr_WI: 'Pmax WI',
  pmax_Corr_CSS: 'Pmax SCS',
  p50: 'P50',
  p50_Corr_F50_CSS: 'P50 F50 SCS',
  p50_Corr_MTPH: 'P50 MTPH',
  p50_Corr_SPEED: 'P50 SPEED',
  p50_Corr_WI: 'P50 WI',
  p50_Corr_CSS: 'P50 SCS',

  shenck: 'Schenck',

  biFlow: 'biFlow',
  rotorLoad: 'rotorLoad',
  rotorCapacity: 'rotorCapacity',
  biFlowTonnage: 'biFlowTonnage',
  liveBinVolume: 'liveBinVolume',

  powerLoad: 'Power load',
  reductionRatio: 'Reduction ratio F80/P80',
  finesFactor: 'finesFactor',
  moistureFactor: 'moistureFactor',
  densityFactor: 'densityFactor',
  f100MaxFeedSizeRatio: 'Actual F100/Max feed size',

  crusherLoad: 'Crusher load',
  screenLoad: 'Screen load',
  returnToCrusher: 'Return flow to crusher',

  grizzlyLoadDeck1: 'Grizzly Load Deck 1',
  grizzlyLoadDeck2: 'Grizzly Load Deck 2',
  undersizeTopsize: 'Top size in undersize',
  separationSize: 'Separation Size',
  overUnderSizeDemand: 'Oversize / Undersize demand',
  bedDepthFeedEnd: 'Bed depth feed end',
  bedLoadFeedEnd: 'Bed load feed end',
  bedLoadFeedEndMM: 'Bed load feed end (mm)',
  bedDepthFeedMaxRec: 'Bed depth feed end (Max rec.)',
  bedDepthDischargeEnd: 'Bed depth discharge end',
  bedLoadDischargeEnd: 'Bed load discharge end',
  bedLoadDischargeMaxRec: 'Bed load discharge end (Max rec.)',
  bedDepthDischargeMaxRec: 'Bed depth discharge end (Max rec.)',
  bedLoadDischargeMinRec: 'Bed load discharge end (Min rec.)',
  bedLoadOver: 'Bed load over',
  bedDepthDischarge: 'Bed depth discharge',
  bedDepthDischargeMax: 'Bed depth discharge max (mm)',
  bedDepthDischargeMin: 'Bed depth discharge min (mm)',
  bedDepthDischargeMinMax: 'Bed depth discharge end (min, max)',

  screeningMediaId: 'Screening media',

  areaLoad: 'Area load',
  rotorAndBiFlowLoad: 'Load (Rotor load+Bi-flow load)',

  efficiency: 'Efficiency',
  cn: 'cn',
  q1: 'q1',
  q2: 'q2',
  q3: 'q3',
  q4: 'q4',
  q5: 'q5',
  q6: 'q6',

  reqDimensions: 'Required screen area dimensions (W x L)',
} as const;

export type ReportTableKey = keyof typeof keys;
export type ReportTableValues = (typeof keys)[ReportTableKey];

export default keys;
